"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTrackPreviewUrl = exports.getImageUrl = exports.getResizedImageUrl = exports.ResizeMode = void 0;
var STATICS_BASE_URL = 'https://static.wixstatic.com/media/';
var TRACK_BASE_URL = 'https://music.wixstatic.com/preview/';
var FILE_NAME_RE = /^[a-z0-9_-]+\.[a-z0-9]+$/i;
var PREVIEW_URL = /preview\/([a-z0-9_-]+\.[a-z0-9]+$)/i;
var IMAGE_SOURCE_NAME = 'mscdsh';
var JPEG_PARAMS = {
    q: 85,
    usm: '0.66_1.00_0.01',
};
var ResizeMode;
(function (ResizeMode) {
    ResizeMode["Fill"] = "fill";
    ResizeMode["Fit"] = "fit";
})(ResizeMode = exports.ResizeMode || (exports.ResizeMode = {}));
var isJPEG = function (extension) { return /^jpe?g$/i.test(extension); };
var getResizedImageUrl = function (url, width, height, mode) {
    if (height === void 0) { height = width; }
    if (mode === void 0) { mode = ResizeMode.Fill; }
    if (!url) {
        return;
    }
    if (width <= 0 || height <= 0) {
        throw new Error("Invalid size. width: ".concat(width, ", height: ").concat(height));
    }
    var fullFilename = url.replace(/.*\//, '');
    var filenameSplitted = fullFilename.split('.');
    var filename = filenameSplitted.slice(0, -1).join('.');
    var ext = filenameSplitted[filenameSplitted.length - 1];
    var imageUrlEnd = IMAGE_SOURCE_NAME ? "".concat(filename, "_").concat(IMAGE_SOURCE_NAME, ".").concat(ext) : "".concat(filename, ".").concat(ext);
    var imageParamsPath = "w_".concat(Math.round(width), ",h_").concat(Math.round(height));
    if (isJPEG(ext)) {
        imageParamsPath = "".concat(imageParamsPath, ",q_").concat(JPEG_PARAMS.q, ",usm_").concat(JPEG_PARAMS.usm);
    }
    var imagePath = "".concat(fullFilename, "/v1/").concat(mode, "/").concat(imageParamsPath, "/").concat(imageUrlEnd);
    return "".concat(STATICS_BASE_URL).concat(imagePath);
};
exports.getResizedImageUrl = getResizedImageUrl;
function getImageUrl(url) {
    return "".concat(STATICS_BASE_URL).concat(url);
}
exports.getImageUrl = getImageUrl;
function getTrackPreviewUrl(fileId) {
    if (isValidStaticUrl(fileId)) {
        var trackId = getFileIdFromTrackUrl(fileId);
        return getTrackPreviewUrl(trackId);
    }
    if (!isValidStaticId(fileId)) {
        throw new Error('Track url is invalid');
    }
    return TRACK_BASE_URL + fileId;
}
exports.getTrackPreviewUrl = getTrackPreviewUrl;
function isValidStaticId(id) {
    if (!id || typeof id !== 'string') {
        return;
    }
    return FILE_NAME_RE.test(id);
}
function isValidStaticUrl(id) {
    if (!id || typeof id !== 'string') {
        return;
    }
    return PREVIEW_URL.test(id);
}
function getFileIdFromTrackUrl(url) {
    var match = url.match(PREVIEW_URL);
    return match ? match[1] : undefined;
}
//# sourceMappingURL=media.js.map